import React, { Component } from "react";
import { Tooltip } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  AccordionHeading,
  Border,
  AccordionWrapper,
  AccordionHeaderWrapper,
  FlexCenter,
  EmptyMessage
} from './styles';
import ListViewDocument from './ListViewDocument';
import { recordError } from "../../../utils/commonUtil";
import { CapsuleButton } from './../../../CommonComponents/Commons/commonComponents';

let showMoreData = [];
let checkboxData = [false, false, false, false, false, false];
let AccordionArray = ['Contribution confirmations or tax records', 'Grant confirmations', 'Other Transactions', 'Statements', 'Account documentation', 'Non-account specific documentation']
export class ListViewAccordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dummy: false,
      showMoreClicked: true
    }
  }

  componentDidMount() {
    showMoreData = []
  }

  ShowMoreButtonClick = (index) => {
    try {
      showMoreData[index] = !showMoreData[index];
      this.setState({ dummy: true });
    } catch (error) {
      recordError(error);
    }
  }

  handleCheckboxChangeChild = (id, value) => {
    checkboxData[id] = value ? value : null;
    this.setState({ dummy: false })
  }

  render() {
    if (showMoreData.length === 1) {
      this.props.arrayData.map((index) => {
        showMoreData[index] = false;
      })
    }
    return (
      <div data-test="document-center-list-view-accordion">
        {
          (this.props.arrayData.length === 0) ?
            AccordionArray.map((each, index) => {
              return (
                <AccordionWrapper marginBottom='20px' key={`list-confirmations-${index}`}>
                  <AccordionHeaderWrapper>
                    <FlexCenter>
                      <AccordionHeading> {each}</AccordionHeading>
                    </FlexCenter>
                  </AccordionHeaderWrapper>
                  <Border />
                  <AccordionWrapper marginTop="30px" marginBottom="50px">
                    <div class='ant-empty ant-empty-normal'>
                      <EmptyMessage class='ant-empty-description'>
                        You currently have no documents for the time period selected.
                     </EmptyMessage>
                    </div>
                  </AccordionWrapper>
                </AccordionWrapper>
              )
            })
            :
            (this.props.arrayData).map((each, index) => (
              <AccordionWrapper key={`list-documentation-${index}`}>
                <AccordionHeaderWrapper>
                  <FlexCenter>
                    <Tooltip placement="topLeft" title="Add to Download Selected List">
                    </Tooltip>
                    <AccordionHeading> {each[0]} ({each[1].length})</AccordionHeading>
                  </FlexCenter>
                  {(this.props.arrayData && each[1].length >= 7) ?
                    <>
                      {showMoreData[index]
                        ? <CapsuleButton data-test='list-view' alt="Show Less" text="Show Less" iconType="arrowUp" onClick={() => this.ShowMoreButtonClick(index)} />
                        : <CapsuleButton data-test='list-view1' alt="Show More" text="Show More" iconType="arrowDown" onClick={() => this.ShowMoreButtonClick(index)} />
                      }
                    </>
                    :
                    ""
                  }
                </AccordionHeaderWrapper>
                <Border />
                <AccordionWrapper marginTop="30px" marginBottom="50px">
                  {(each && each[1].length === 0) ?
                    <div class='ant-empty ant-empty-normal'>
                      <EmptyMessage class='ant-empty-description'>
                        You currently have no documents for the time period selected.
                      </EmptyMessage>
                    </div>
                    :
                    <ListViewDocument
                      eachId={index}
                      docVal={each}
                      showMore={showMoreData[index]}
                      checkbox={checkboxData[index]}
                      handleCheckboxChange={this.handleCheckboxChangeChild}
                    />
                  }
                </AccordionWrapper>
              </AccordionWrapper>
            ))
        }
      </div>
    )
  }
}

ListViewAccordion.propTypes = {
  arrayData: PropTypes.array
}

const mapStateToProps = state => ({
  arrayData: state.getIn(['documentCentre', 'filteredData']),
});

export default connect(mapStateToProps)(ListViewAccordion);

